import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core'

import { Required } from '@app/core/decorators/required'
import { ConfirmableWithPayload } from '@app/modules/ui/models/confirmable-with-payload'
import { UIModule } from '@app/modules/ui/ui.module'
import { MemberService } from '@app/services/member.service'

type Action = 'Buy Credits' | 'Send'

@Component({
  selector: 'sb-message-photo-album-insufficient-credits-modal',
  templateUrl: './message-photo-album-insufficient-credits-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoAlbumInsufficientCreditsModalComponent extends ConfirmableWithPayload<Action> {
  readonly memberService = inject(MemberService)

  @Required @Input() affordablePhotosCount!: number
  @Required @Input() mode!: 'upload' | 'send'
}
